import { Button, Form, Input, message, Modal, notification, Select } from "antd";
import React, { useState, useEffect } from "react";
import gql from "../../api/gql";
const CreateOrUpdateProductShortLink = ({ product, site_id }) => {
  const [open, setOpen] = useState(false);

  const { Option } = Select;
  const [type, setType] = useState("product");
  const [short_text, setShort_text] = useState("");

  const [productLink, setProductLink] = useState("");
  const [categoryLink, setCategoryLink] = useState("");

  const [adsLink, setAdsLink] = useState("");
  const [loading, setLoading] = useState(false);

  const checkdisabled = () => {
    if (!type) return true;
    if (type === "product") {
      return !productLink;
    }
    if (type === "category") {
      return !productLink || !categoryLink;
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (product?.ads_short_link) {
      setAdsLink(product.ads_short_link);
    }
  }, [product]);
  useEffect(() => {
    if (product?.ads_short_link) {
      setAdsLink(product.ads_short_link);
    }
  }, [product]);
  const handleCreareORUpdate = () => {
    if (checkdisabled()) {
      message.error("Please enter complete information!");
      return;
    }
    setLoading(true);
    const mutation = `mutation createProductShortLin111k(
        $site_id: String!,
        $origin_id: String!,
        $product_link: String!,
        $category_link: String!,
        $type_set: String!
        $short_text: String!
    ){
      createProductShortLink(
        site_id: $site_id,
        origin_id: $origin_id,
        product_link: $product_link,
        category_link: $category_link,
        type_set: $type_set
        short_text: $short_text
      ){
        path_link,
        target_link,
        ads_link
      }
    }`;
     const currentForSite = product.product_stores.find(
       (e) => e.site_id === site_id,
     );
     const origin_id = currentForSite
       ? currentForSite.origin_id
       : product[0].origin_id;
    gql
      .request(mutation, {
        site_id,
        origin_id: origin_id,
        category_link: type == "category" ? categoryLink : "",
        product_link: productLink,
        type_set: type,
        short_text,
      })
      .then((res) => {
        return res.createProductShortLink;
      })
      .then((res) => {
        if (res?.ads_link) {
          setAdsLink(res.ads_link);
          message.success("Tạo thành công!");
        } else {
          message.error(
            "Creation failed!, Please check the input and try again!",
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        message.error(
          "Creation failed!, Please check the input and try again!",
        );
        setLoading(false);
      });
  };
  return (
    <>
      <Modal
        title="Create/ Edit Short Link"
        destroyOnClose={true}
        onCancel={handleCancel}
        visible={open}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            disabled={checkdisabled()}
            onClick={handleCreareORUpdate}
            loading={loading}
            type="primary"
          >
            Submit
          </Button>,
        ]}
      >
        <Form layout="vertical" className="form_short_link">
          <Form.Item label="Type:">
            <Select
              style={{ width: 180 }}
              value={type}
              onChange={(value) => setType(value)}
            >
              <Option value="product">Product</Option>
              <Option value="category">Category</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Product link:">
            <Input
              value={productLink}
              onChange={(e) => setProductLink(e.target.value)}
              style={{
                marginTop: 10,
              }}
              placeholder="Please enter the product link"
            />
          </Form.Item>
          {type != "product" && (
            <Form.Item label="Category link:">
              <Input
                value={categoryLink}
                onChange={(e) => setCategoryLink(e.target.value)}
                style={{
                  marginTop: 10,
                }}
                placeholder="Please enter the category link"
              />
            </Form.Item>
          )}

          <Form.Item label="Short text:">
            <Input
              value={short_text}
              onChange={(e) => setShort_text(e.target.value)}
              style={{
                marginTop: 10,
              }}
              placeholder="Please enter a short text. Example: Abc123"
            />
          </Form.Item>

          {adsLink && (
            <div style={{}}>
              <Form.Item label="Short link:">
                <Input
                  onClick={() => {
                    const coppy = navigator.clipboard.writeText(adsLink);
                    if (coppy) {
                      notification.success({
                        message: "Successfully copied short link " + adsLink,
                      });
                    }
                  }}
                  type="text"
                  value={adsLink}
                  style={{
                    background: "#fafafa",
                    color: "#ff9100",
                    cursor: "pointer",
                  }}
                  readOnly
                />
              </Form.Item>
            </div>
          )}
        </Form>
      </Modal>
      <Button onClick={() => setOpen(true)}>Short Link</Button>
    </>
  );
};

export default CreateOrUpdateProductShortLink;
